// extracted by mini-css-extract-plugin
export default {"JHeroSection":"JHero_JHeroSection__2Je-2"};